// constants
import { BOOKING_STATE_VALUE_PROMISED } from "@cloudspire/legacy-resources/src/constants/booking";

export default function bookingIsStatePromised({ booking }) {
  return BOOKING_STATE_VALUE_PROMISED === booking.state;
}
